import React, {lazy} from 'react';
import ReactDOM from 'react-dom/client';
import './input.css';
import reportWebVitals from './reportWebVitals';

import Login from "./pages/login";
import {createBrowserRouter, createRoutesFromElements, Route, RouterProvider} from "react-router-dom";
import ForgetPassword from "./pages/forget-password";
import './i18n';

import Loading from "./components/other/Loading";
import Setting from "./pages/Setting";
import ChartPage from "./pages/Chart";
const Planning = lazy(() => import('./pages/Planning'));
const TimeLine = lazy(() => import('./pages/TimeLine'));
const Home = lazy(() => import('./pages/home'));
const PlanningModifAdd = lazy(() => import('./pages/PlanningModifAdd'));
const CodeForgetPassword = lazy(() => import('./pages/CodeForgetPassword'));
const Image = lazy(() => import('./pages/Image'));
const Chart = lazy(() => import('./pages/Chart'));
const Roles = lazy(() => import('./pages/Roles'));


const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route index element={<Login />} />
            <Route path="login" element={<Login />} />
            <Route path="forget-password" element={<ForgetPassword />} />
            <Route path="codeforgetpassword" element={<CodeForgetPassword />} />
            <Route path="Home" element={<Home />} />
            <Route path="Planning" element={<Planning view='time' />} />
            {/*<Route path="Calendar" element={<Planning view='task' />} /> */}
            <Route path="Timeline" element={<TimeLine />} />

            {/* TODO clean Roles route */}
            <Route path="Roles" element={<Roles />} />
            <Route path="Management" element={<Roles />} />

            <Route path="planningmodif" element={<PlanningModifAdd />} />
            <Route path="planningadd" element={<PlanningModifAdd />} />
            
            <Route path="Settings" element={<Setting />} />
            <Route path="Image" element={<Image />} />
            <Route path="Chart" element={<Chart />} />
        </>
    )
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <React.Suspense fallback={<Loading />}>
            <RouterProvider router={router} />
        </React.Suspense>
    </React.StrictMode>
);

reportWebVitals();
